import Helpers from "commons/helpers";
import Constants from "constants/index";
import IdentityService from "./identity.service";
import { BooleanInt } from "constants/enum";

class GroupService extends IdentityService {

    public getAll = async (data: {
        clientId?: string;
        organizationId?: string;
        includeCompany?: number;
        nonHierarchical?: BooleanInt;
        listStatus?: number[];
    }) => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.GROUP.GET_ALL + `${query ? "?" : ""}${query}`,
        });
        return result.data.result;
    };

    public getPaged = async (data: {
        clientId?: string;
        organizationId?: string;
        searchText?: string;
        listStatus?: number[];
        nonHierarchical?: BooleanInt;
        orderby?: string;
        pageSize?: number;
        pageNumber?: number;
    }) => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.GROUP.GET_PAGED + `${query ? "?" : ""}${query}`,
        });
        return result.data.result;
    };
}

export default GroupService;
